
import { object, array, number, string } from 'yup'

export const dunValidationSchema = object({
  ListDun: array(
    object({
      dun: string().required('el dun es requerido')
      .min(14, 'El dun debe ser de 14 caracteres')
      .max(14, 'El dun debe ser de 14 caracteres'),
      quantity: number().required('la cantidad es requerida').min(1, 'La cantidad minima debe ser 1'),
      description: string().required('La descripción es requerida')
    })
  ).max(9)
})